import { useContext } from 'react'

import { JobsContext, type JobsValue } from './context'

export function useJobsContext(): JobsValue {
  return useContext(JobsContext)
}
